
import { Options, Vue } from "vue-class-component";
import Header from "./Header/Header.vue";
import Content from "./Content/Content.vue";
import Footer from "./Footer/Footer.vue";
@Options({
  components: {
    Header,
    Content,
    Footer
  }
})
export default class Login extends Vue {
  public layout = {
    header: {
      show: true
    },
    content: {
      show: true
    },
    footer: {
      show: true
    }
  };
}
